/* @flow */

import { Component } from 'react';
import { createPortal } from 'react-dom';
import { slideInDown, slideInUp } from 'react-animations';
import { map, sum } from 'lodash/fp';
import { css } from 'glamor';
import { withTheme } from 'glamorous';

type Props = {
  children: any,
  disabled?: boolean,
  fillSpace?: boolean,
  placement: 'bottom' | 'top',
  position?: 'absolute' | 'fixed',
  theme: Object,
  type?: 'alert' | 'notification' | 'sticky',
};

const slideInDownAnimation = css.keyframes(slideInDown);
const slideInUpAnimation = css.keyframes(slideInUp);

class FixToViewport extends Component<Props> {
  props: Props;
  node: HTMLElement; // eslint-disable-line react/sort-comp

  static defaultProps = {
    disabled: false,
    fillSpace: false,
    position: 'fixed',
    type: 'sticky',
  };

  constructor(props: Props, ...args: Array<*>) {
    super(props, ...args);

    this.node = document.createElement('div');
    this.node.className = css({
      animationDuration: '0.5s',
      animationName: props.placement === 'top' ? slideInDownAnimation : slideInUpAnimation,
      left: 0,
      [props.placement]: '90px',
      position: props.position,
      right: 0,
      zIndex: props.theme.zIndex[props.type],
    }).toString();
  }

  componentDidMount() {
    const { disabled, fillSpace } = this.props;

    if (!disabled) {
      this.appendNode();
      if (fillSpace) {
        this.padBody();
      }
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { disabled, fillSpace } = this.props;

    if (!disabled) {
      if (prevProps.disabled) {
        this.appendNode();
      }
      if (fillSpace) {
        this.padBody();
      }
    } else if (!prevProps.disabled) {
      this.destroyNode();
    }
  }

  componentWillUnmount() {
    const { disabled } = this.props;

    if (!disabled) {
      this.destroyNode();
    }
  }

  appendNode() {
    // $FlowIgnore
    document.body.appendChild(this.node);
  }

  padBody() {
    const { placement } = this.props;

    const height = sum(map('offsetHeight', this.node.children));
    // $FlowIgnore
    document.body.style.setProperty(`padding-${placement}`, `${height}px`);
  }

  destroyNode() {
    const { fillSpace, placement } = this.props;

    // $FlowIgnore
    document.body.removeChild(this.node);
    if (fillSpace) {
      // $FlowIgnore
      document.body.style.removeProperty(`padding-${placement}`);
    }
  }

  render() {
    const { children, disabled } = this.props;

    return disabled ? children : createPortal(children, this.node);
  }
}

export default withTheme(FixToViewport);
